import createClient from 'openapi-fetch';
import type { paths } from './schema';
import { env } from '@/lib/env';
import { useAuth } from '@/features/auth/auth-store';
import { useSubscriptionStore } from '@/features/subscription/useSubscriptionStore';
import { refreshAccessToken } from './http';

export const api = createClient<paths>({
  baseUrl: env.VITE_API_BASE_URL,
  credentials: 'include',
  fetch: async (request: Request) => {
    const retryReq = request.clone();
    const token = useAuth.getState().accessToken;
    const headers = new Headers(request.headers);
    if (token) headers.set('Authorization', `Bearer ${token}`);
    let res = await fetch(new Request(request, { headers }));
    if (res.status === 401) {
      try {
        await refreshAccessToken();
        const fresh = useAuth.getState().accessToken;
        const retryHeaders = new Headers(retryReq.headers);
        if (fresh) retryHeaders.set('Authorization', `Bearer ${fresh}`);
        res = await fetch(new Request(retryReq, { headers: retryHeaders }));
      } catch { /* auth store already flipped to anon in refreshAccessToken */ }
    }

    const store = useSubscriptionStore.getState();
    const expiresIn = res.headers.get('x-subscription-expires-in');
    if (expiresIn != null) {
      const days = Math.floor(Number(expiresIn));
      if (Number.isFinite(days)) store.setDaysLeft(days);
    }
    if (res.ok && useSubscriptionStore.getState().blocked) store.setBlocked(false);
    if (res.status === 403) {
      const body = await res.clone().json().catch(() => null) as { error?: { code?: string } } | null;
      if (body?.error?.code === 'subscription_inactive') store.setBlocked(true);
    }

    return res;
  },
});
